export default __webpack_public_path__ + "static/media/IMAGEM-HEADER-OBSERVATÓRIO.650300e3.svg";